export function apiFactory(props) {
  const apiCommonMethods = props?.methods ?? [
    ['saveWorklog', '/trello/v2/saveWorklog', 'POST'],
    ['setTimerState', '/trello/setLiveWorklog', 'POST'],
    ['updateWorklog', '/trello/v2/updateWorklog', 'PUT'],
    ['deleteWorklog', '/trello/v2/deleteWorklog', 'DELETE'],
    ['getWorklogs', '/trello/getWorklogs', 'POST'],
    ['getWorklogsMeta', '/trello/getWorklogsMeta', 'POST'],
    ['getCardsStats', '/trello/v2/getCardsStats', 'POST'],
    ['getCardsArchive', '/trello/getCardsArchive', 'POST'],
    ['deleteScreenshot', '/trello/deleteScreenshot', 'POST'],
    ['getBoardAdminSettings', '/trello/settings/boardAdminSettings', 'GET'],
    ['getBoardUsersPermissions', '/trello/getBoardUsersPermissions', 'POST'],
    ['setBoardUsersPermissions', '/trello/setBoardSettings', 'POST'],
    ['getBoardMemberSettings', '/trello/getBoardMemberSettings', 'GET'],
    ['setBoardMemberSettings', '/trello/setBoardMemberSettings', 'POST'],
    ['setBoardAutoList', '/trello/setBoardAutoList', 'POST'],
    ['setInvoiceData', '/trello/setInvoiceData', 'POST'],
    ['subscription', '/trello/subscription', 'POST'],
    ['checkOrder', '/trello/checkOrder', 'POST'],
    ['initialize', '/trello/initialize', 'POST'],
    ['getBillingInfo', '/trello/getBillingInfo', 'POST'],
    ['getBillingHistory', '/trello/getBillingHistory', 'GET'],
    ['getFondyPayUrl', '/trello/getFondyPayUrl', 'POST'],
    ['getPayUrl', '/trello/getPayUrl', 'POST'],
    ['makeTestPayment', '/trello/makeTestPayment', 'POST'],
    ['saveTestWorkspaceBilling', '/trello/saveTestWorkspaceBilling', 'POST'],
    ['getPwaAuthKey', '/trello/getPwaAuthKey', 'GET'],
    ['getLastNews', '/trello/getLastNews', 'GET'],
    ['readLastNews', '/trello/readLastNews', 'POST'],
    ['getEstimates', '/trello/estimates', 'GET'],
    ['getBunchEstimates', '/trello/estimates/bunch', 'POST'],
    ['addEstimate', '/trello/estimates', 'POST'],
    ['updateEstimate', '/trello/estimates/{id}', 'PUT'],
    ['deleteEstimate', '/trello/estimates/{id}', 'DELETE'],
    ['migrateEstimates', '/trello/estimates/migrate', 'POST'],
  ];

  const headers = {
    Accept: 'application/json',
    Authorization: 'Bearer null',
    'Content-Type': 'application/json',
  };
  let makeRequest = props?.makeRequest ?? (() => {});
  let mockMethods = {};
  let token = null;
  let apiBaseUrl = null;

  function fillUrlTemplate(template, templateVars) {
    const re = new RegExp('{', 'g');
    return new Function(
      /* eslint-disable-line */ `return \`${template.replace(re, '${this.')}\`;`
    ).call(templateVars);
  }

  function buildQueryUrl(endpointUrl, params = {}) {
    const urlInstance = new URL(
      `${apiBaseUrl}${fillUrlTemplate(endpointUrl, params)}`
    );

    urlInstance.search = new URLSearchParams(params);
    return urlInstance.toString();
  }

  function performFetch({ methodName, endpointUrl, method, params, body }) {
    const url = buildQueryUrl(endpointUrl, params);

    if (mockMethods[methodName]) {
      return mockMethods[methodName]({
        ...params,
        url,
        endpointUrl,
        headers,
        ...(Object.keys(body).length
          ? {
              data: JSON.stringify(body),
            }
          : {}),
      });
    }

    return makeRequest({
      url,
      method,
      headers,
      ...(Object.keys(body).length
        ? {
            data: JSON.stringify(body),
          }
        : {}),
    });
  }

  return {
    init({ req, baseUrl }) {
      if (req) {
        makeRequest = req;
      }
      if (baseUrl) {
        apiBaseUrl = baseUrl;
      }
    },

    setMockMethods(mockObject, merge = true) {
      mockMethods = merge
        ? {
            ...mockMethods,
            ...mockObject,
          }
        : mockObject;

      return mockMethods;
    },

    clearMockMethods() {
      mockMethods = {};
      return mockMethods;
    },

    setJWT(jwt) {
      token = jwt;
      headers.Authorization = `Bearer ${jwt}`;
    },

    getJWT() {
      return token;
    },

    ...apiCommonMethods.reduce(
      (acc, [methodName, endpointUrl, method = 'GET']) => ({
        ...acc,
        [methodName](
          { params = {}, body = {} } = {
            params: {},
            body: {},
          }
        ) {
          return performFetch({
            methodName,
            endpointUrl,
            method,
            params,
            body,
          });
        },
      }),
      {}
    ),
  };
}

const api = apiFactory();

export default api;
